/** Public recipient projection only: omit wire metadata, never content. */
const metadata = new Set([
  "id",
  "userId",
  "order",
  "templateId",
  "snapshot",
  "isSubmitted",
  "isPublic",
  "slug",
  "createdAt",
  "updatedAt",
  "profileAccess",
  "type",
]);
export type DisclosureField = {
  path: string;
  label: string;
  value: string;
  photo?: boolean;
};
export function disclosureFields(value: unknown): DisclosureField[] {
  const fields: DisclosureField[] = [];
  function walk(node: unknown, path: string[], label: string) {
    if (node === null || node === undefined || node === "") return;
    if (typeof node === "string") {
      fields.push({
        path: path.join("."),
        label,
        value: node,
        photo: label === "image" || label === "avatarUrl",
      });
      return;
    }
    if (typeof node === "boolean") {
      if (node && (label === "current" || label === "isCurrent"))
        fields.push({ path: path.join("."), label, value: "" });
      return;
    }
    if (typeof node === "number") {
      fields.push({ path: path.join("."), label, value: String(node) });
      return;
    }
    if (Array.isArray(node)) {
      node.forEach((child, index) =>
        walk(child, [...path, String(index)], label),
      );
      return;
    }
    if (typeof node === "object")
      for (const [key, child] of Object.entries(node)) {
        if (!metadata.has(key))
          walk(child, [...path, key], key === "data" ? label : key);
      }
  }
  walk(value, [], "additional");
  return fields;
}
